/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Home_Card_DescInputs */

const en_dr_home_card_desc = /** @type {(inputs: Dr_Home_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agree on the problem, users and hypotheses with your team or client first — Bystep turns the room into the PRD.`)
};

const id_dr_home_card_desc = /** @type {(inputs: Dr_Home_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepakati masalah, pengguna, dan hipotesis bersama tim atau klien dulu — Bystep mengubah ruang itu jadi PRD.`)
};

/**
* | output |
* | --- |
* | "Agree on the problem, users and hypotheses with your team or client first — Bystep turns the room into the PRD." |
*
* @param {Dr_Home_Card_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_home_card_desc = /** @type {((inputs?: Dr_Home_Card_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Home_Card_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_home_card_desc(inputs)
	return en_dr_home_card_desc(inputs)
});